import React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import AppTwoFaEnableModal from '../AppTwoFaModals/AppTwoFaEnableModal';
import AppTwoFaDisableModal from '../AppTwoFaModals/AppTwoFaDisableModal';
import useWindowSize from '../../utils/resizeHook';
import { identity } from '../../utils/getIdentity';

const AppTwoFaForm = ({ isTwoFactorEnabled }) => {
  const { t } = useTranslation();
  const { currentWidth } = useWindowSize();

  return (
    <div className={`profile-block profile-block-${identity}`}>
      <span className={`profile__title profile__title-${identity}`}>
        {t('profile.twoFactorAuthentication')} (
        <span className={isTwoFactorEnabled ? 'profile__title_enabled' : 'profile__title_disabled'}>
          {isTwoFactorEnabled ? t('profile.enabled') : t('profile.disabled')}
        </span>
        )
      </span>
      <span className={`profile__subtitle profile__subtitle-${identity}`}>{t('profile.useTwoFaFor')}</span>
      <Row gutter={[20, 0]}>
        <Col span={currentWidth >= 1024 ? 4 : 24}>
          {isTwoFactorEnabled ? <AppTwoFaDisableModal /> : <AppTwoFaEnableModal />}
        </Col>
      </Row>
    </div>
  );
};

export default AppTwoFaForm;
